const Close = () => <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />;

export default Close;
